import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const useLawyerReviews = (orgId, cardRef) => {
  const [reviewsData, setReviewsData] = useState({ reviews: [], stats: null });
  const [loading, setLoading] = useState(false);
  const reviewsLoaded = useRef(false);

  useEffect(() => {
    if (orgId && cardRef.current) {
      const observer = new IntersectionObserver(
        async (entries) => {
          if (entries[0].isIntersecting && !reviewsLoaded.current) {
            setLoading(true);
            try {
              const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/organisations/${orgId}/reviews`);
              setReviewsData(response.data);
              reviewsLoaded.current = true;
            } catch (error) {
              console.error('Error loading reviews:', error);
            } finally {
              setLoading(false);
            }
          }
        },
        { threshold: 0.1 }
      );

      observer.observe(cardRef.current);
      return () => observer.disconnect();
    }
  }, [orgId, cardRef]);

  return { reviewsData, loading };
};

export default useLawyerReviews; 